import { render } from "./AdminAddAgent.vue?vue&type=template&id=fc4ec0a0&scoped=true"
import script from "./AdminAddAgent.vue?vue&type=script&lang=js"
export * from "./AdminAddAgent.vue?vue&type=script&lang=js"

import "./AdminAddAgent.vue?vue&type=style&index=0&id=fc4ec0a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4ec0a0"]])

export default __exports__